import { ProductFormDescriptionField } from '@/core/components/products/product-form-fields/description-field';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { isCapacitorNative } from '@/core/utils/capacitor.utils';
import { ProductsSetupStepShell } from '@/routes/app/products-setup-wizard/products-setup-step-shell';

export function ProductsSetupStepDescription({
  value,
  onChange,
  isBusinessCard = false,
}: {
  value: string;
  onChange: (value: string) => void;
  /** Business cards get card examples instead of “Kasse 1, Tisch 3”. */
  isBusinessCard?: boolean;
}) {
  const dict = useDictionary();
  const setup = (dict as { products?: { setup?: Record<string, string> } })
    .products?.setup;
  const editLabel = (dict as { products?: { edit?: { description?: string } } })
    .products?.edit?.description;

  return (
    <ProductsSetupStepShell
      title={setup?.descriptionStepTitle ?? ''}
      description={
        isBusinessCard
          ? setup?.descriptionStepDescriptionBusinessCard
          : setup?.descriptionStepDescription
      }
    >
      <ProductFormDescriptionField
        id="setup-product-description"
        value={value}
        onChange={onChange}
        label={setup?.descriptionLabel ?? editLabel}
        placeholder={
          isBusinessCard
            ? setup?.descriptionPlaceholderBusinessCard
            : setup?.descriptionPlaceholder
        }
        hint={
          isBusinessCard
            ? setup?.descriptionHintBusinessCard
            : setup?.descriptionHint
        }
        required={false}
        autoFocus={!isCapacitorNative()}
      />
    </ProductsSetupStepShell>
  );
}
